export enum JobStatus {
  None = 'None',
  Scheduled = 'Scheduled',
  Running = 'Running',
  Successful = 'Successful',
  PartiallySuccessful = 'PartiallySuccessful',
  Failed = 'Failed',
  Cancelled = 'Cancelled'
}
